export const BIOMETRIA_LIMIT_HOURS = 72;

const HOUR_IN_MS = 60 * 60 * 1000;
const MINUTE_IN_MS = 60 * 1000;
const VX_TIMEZONE_OFFSET_HOURS = -3;

const normalizeText = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim();

const pad = value => String(value).padStart(2, '0');

export const isVxBiometriaPending = response => {
  const status = normalizeText(response?.status || response?.dados_vx?.status);
  return status === 'aguardando biometria';
};

export const getVxDataPesquisa = response => response?.dados_vx?.data_pesquisa
  || response?.dados_vx?.dataPesquisa
  || response?.data_pesquisa
  || response?.dataPesquisa
  || null;

export const normalizeVxDateToUtcMinus3 = value => {
  if (!value) return null;

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return null;

  return new Date(parsedDate.getTime() + (VX_TIMEZONE_OFFSET_HOURS * HOUR_IN_MS));
};

export const formatVxDateTime = date => {
  if (!date) return '-';

  return [
    `${pad(date.getUTCDate())}/${pad(date.getUTCMonth() + 1)}/${date.getUTCFullYear()}`,
    `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
  ].join(' ');
};

export const getVxBiometriaCountdown = (response, now = new Date()) => {
  const dataPesquisa = getVxDataPesquisa(response);
  const createdAt = normalizeVxDateToUtcMinus3(dataPesquisa);

  if (!createdAt) return null;

  const expiresAt = new Date(createdAt.getTime() + (BIOMETRIA_LIMIT_HOURS * HOUR_IN_MS));
  const normalizedNow = new Date(now.getTime() + (VX_TIMEZONE_OFFSET_HOURS * HOUR_IN_MS));
  const remainingMs = expiresAt.getTime() - normalizedNow.getTime();
  const isExpired = remainingMs <= 0;
  const safeRemainingMs = Math.max(0, remainingMs);
  const hours = Math.floor(safeRemainingMs / HOUR_IN_MS);
  const minutes = Math.floor((safeRemainingMs % HOUR_IN_MS) / MINUTE_IN_MS);

  return {
    dataPesquisa,
    createdAt,
    expiresAt,
    isExpired,
    hours,
    minutes,
    createdAtLabel: formatVxDateTime(createdAt),
    expiresAtLabel: formatVxDateTime(expiresAt),
    remainingLabel: isExpired ? 'Prazo expirado' : `${hours}h ${pad(minutes)}min restantes`
  };
};
